module.exports = __webpack_public_path__ + "web/img/mp4.ede7e09a.png";